import { tr, type TrKey } from "./tr";

const DICT: Record<string, string> = tr;

/**
 * t(key, params?) — sozluk anahtar → metin. Anahtar sozlukte YOKSA anahtarin
 * kendisi dondurulur (sessiz "undefined" yerine gozle gorulur bir eksik).
 * `{{ad}}` bicimli yer tutucular params ile degistirilir.
 */
// eslint-disable-next-line @typescript-eslint/ban-types -- kasitli: TrKey icin otomatik tamamlama korunur, digger stringler de kabul edilir.
export function t(key: TrKey | (string & {}), params?: Record<string, string | number>): string {
  const template = DICT[key];
  if (template == null) return key;
  const values = params ?? {};
  return template.replace(/\{\{(\w+)\}\}/g, (_match, name: string) =>
    values[name] != null ? String(values[name]) : "",
  );
}

export { tr };
export type { TrKey };
